// Adds scroll to Table of Contents dropdown for Manual
jQuery(document).ready(function () {
    jQuery('#table-of-contents').change( function () {
      var targetPosition = jQuery(jQuery(this).val()).offset().top;
      jQuery('html,body').animate({ scrollTop: targetPosition}, 'slow');
    });
  });
  
  // Changes placeholder text for FCCM's Chosen dropdown
  jQuery(document).ready(function(){
    var fccm_section_select = jQuery('#views-exposed-form-manual-cloud-search-manual-cloud-search-results #edit_title_chosen .chosen-single span');
      jQuery(fccm_section_select).text('All of FCCM');
  });